import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import PricingParametersTable, {
  PRICING_PARAMETER_COLUMNS, PRICING_PARAMETER_CARDS, PRICING_PARAMETER_MIN_TABLE_WIDTH
} from 'components/Tables/PricingParameters';
import * as DataList from 'components/DataList';
import Card from 'components/Card';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';
import BookingsSidebar from '../bookings/bookings-sidebar';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F6F6FA;
  min-height: calc(100vh - 75px);  
`

@inject('store', 'viewStore', 'pricingParameterStore') @observer
class PricingParameterIndexPage extends Component {
  @observable visible = true;

  render() {
    let content;
    let {
      pricingParameterStore,
      pricingParameterStore: {
        pricingParameter: {
          isLoading,
          isError
        }
      }, viewStore
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={PRICING_PARAMETER_COLUMNS}
          cards={PRICING_PARAMETER_CARDS}
          minTableWidth={PRICING_PARAMETER_MIN_TABLE_WIDTH}
          noun="pricing parameters"
        />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="pricing parameters" onRetry={() => pricingParameterStore.loadPricingParameters()} />;
    }
    if (!isError && !isLoading) {
      content = <PricingParametersTable />
    }
    return (
      <div>
        <Helmet>
          <title>Pricing Parameters | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters">
          <div className="col-lg-2 sidebar-responsive">
              <BookingsSidebar />
          </div>
          <div className="col-lg-10">
            <PageWrapGray>
              <Sticky enabled={true} top={0} innerZ={9}>
                <SearchBars.PricingParameterSearch key={viewStore.listFiltersVersion} />
              </Sticky>
              <Card>
                {content}
              </Card>
            </PageWrapGray>
          </div>
        </div>
      </div>
    )
  }
};

export default PricingParameterIndexPage;